import browserDetection from '@wix/santa-browser-detection';
var getUserAgent = function () { var _a; return (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent; };
export var isFirefox = function () {
    var detected = browserDetection(getUserAgent());
    return !!detected.browser.firefox;
};
